<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="mb-3">
        <vs-input :label="$t('description')" :placeholder="$t('description')" v-model="formData.description" class="w-full"/>
        <validation-error :model-error="formDataErrors.description"></validation-error>
      </div>

      <div class="vx-col mb-3">
        <label class="vs-input--label" v-text="$t('start_time')"></label>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
<!--            <v-select :options="hourOptions" :reduce="label => label.value" :placeholder="$t('start_time_hour')" v-model="formData.timeToStartHour" class="md:mb-0" />-->
            <select v-model="formData.timeToStartHour" class="vs-inputx vs-input--input normal md:mb-0">
              <option value="">{{ $t('start_time_hour') }}</option>
              <option v-for="(option, key) in hourOptions" :key="'start_time_hour_' + key" :value="option.value">{{ option.label }}</option>
            </select>
            <validation-error :model-error="formDataErrors.timeToStartHour"></validation-error>
          </div>
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
<!--            <v-select :options="minuteOptions" :reduce="label => label.value" :placeholder="$t('start_time_minute')" v-model="formData.timeToStartMin" class="md:mb-0" />-->
            <select v-model="formData.timeToStartMin" class="vs-inputx vs-input--input normal md:mb-0">
              <option value="">{{ $t('start_time_minute') }}</option>
              <option v-for="(option, key) in minuteOptions" :key="'start_time_minute_' + key" :value="option.value">{{ option.label }}</option>
            </select>
            <validation-error :model-error="formDataErrors.timeToStartMin"></validation-error>
          </div>
        </div>
      </div>

      <div class="vx-col mb-3">
        <label class="vs-input--label" v-text="$t('end_time')"></label>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
<!--            <v-select :options="hourOptions" :reduce="label => label.value" :placeholder="$t('end_time_hour')" v-model="formData.timeToFinishHour" class="md:mb-0" />-->
            <select v-model="formData.timeToFinishHour" class="vs-inputx vs-input--input normal md:mb-0">
              <option value="">{{ $t('end_time_hour') }}</option>
              <option v-for="(option, key) in hourOptions" :key="'end_time_hour_' + key" :value="option.value">{{ option.label }}</option>
            </select>
            <validation-error :model-error="formDataErrors.timeToFinishHour"></validation-error>
          </div>
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
<!--            <v-select :options="minuteOptions" :reduce="label => label.value" :placeholder="$t('end_time_minute')" v-model="formData.timeToFinishMin" class="md:mb-0" />-->
            <select v-model="formData.timeToFinishMin" class="vs-inputx vs-input--input normal md:mb-0">
              <option value="">{{ $t('end_time_minute') }}</option>
              <option v-for="(option, key) in minuteOptions" :key="'end_time_minute_' + key" :value="option.value">{{ option.label }}</option>
            </select>
            <validation-error :model-error="formDataErrors.timeToFinishMin"></validation-error>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('start_day')"></label>
<!--        <v-select :options="weekDayOptions" :reduce="label => label.value" :placeholder="$t('start_day')" v-model="formData.weekDayStart" class="md:mb-0" />-->
        <select v-model="formData.weekDayStart" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('start_day') }}</option>
          <option v-for="(option, key) in weekDayOptions" :key="'start_day_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="formDataErrors.weekDayStart"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('end_day')"></label>
<!--        <v-select :options="weekDayOptions" :reduce="label => label.value" :placeholder="$t('end_day')" v-model="formData.weekDayFinish" class="md:mb-0" />-->
        <select v-model="formData.weekDayFinish" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('end_day') }}</option>
          <option v-for="(option, key) in weekDayOptions" :key="'end_day_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="formDataErrors.weekDayFinish"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('start_date')"></label>
<!--        <v-select :options="monthDayOptions" :reduce="label => label.value" :placeholder="$t('start_date')" v-model="formData.monthDayStart" class="md:mb-0" />-->
        <select v-model="formData.monthDayStart" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('start_date') }}</option>
          <option v-for="(option, key) in monthDayOptions" :key="'start_date_' + key" :value="option.value">{{ $t(option.label) }}</option>
        </select>
        <validation-error :model-error="formDataErrors.monthDayStart"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('end_date')"></label>
<!--        <v-select :options="monthDayOptions" :reduce="label => label.value" :placeholder="$t('end_date')" v-model="formData.monthDayFinish" class="md:mb-0" />-->
        <select v-model="formData.monthDayFinish" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('end_date') }}</option>
          <option v-for="(option, key) in monthDayOptions" :key="'end_date_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="formDataErrors.monthDayFinish"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('start_month')"></label>
<!--        <v-select :options="monthOptions" :reduce="label => label.value" :placeholder="$t('start_month')" v-model="formData.monthStart" class="md:mb-0" />-->
        <select v-model="formData.monthStart" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('start_month') }}</option>
          <option v-for="(option, key) in monthOptions" :key="'start_month_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="formDataErrors.monthStart"></validation-error>
      </div>

      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('end_month')"></label>
<!--        <v-select :options="monthOptions" :reduce="label => label.value" :placeholder="$t('end_month')" v-model="formData.monthFinish" class="md:mb-0" />-->
        <select v-model="formData.monthFinish" class="vs-inputx vs-input--input normal md:mb-0">
          <option value="">{{ $t('end_month') }}</option>
          <option v-for="(option, key) in monthOptions" :key="'end_month_' + key" :value="option.value">{{ option.label }}</option>
        </select>
        <validation-error :model-error="formDataErrors.monthFinish"></validation-error>
      </div>
      <br/>
      <br/>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import TimeCondition from '@/models/TimeCondition'

export default {
  name: 'Shared.TimeConditions.Add',
  data () {
    return {
      formData: {},
      formDataErrors: {}
    }
  },
  props: {
    activeKeyword: {
      required: true,
      type: String
    },
    activeType: {
      required: true,
      type: String
    },
    hourOptions: {
      required: true,
      type: [Object, Array]
    },
    minuteOptions: {
      required: true,
      type: [Object, Array]
    },
    weekDayOptions: {
      required: true,
      type: [Object, Array]
    },
    monthDayOptions: {
      required: true,
      type: [Object, Array]
    },
    monthOptions: {
      required: true,
      type: [Object, Array]
    }
  },
  mounted () {
    EventBus.$on('initTimeConditionResetFormData', this.resetFormData)
    EventBus.$on('initTimeConditionGetFormData', this.getFormData)
    EventBus.$on('initSaveTimeCondition', this.saveFormData)
  },
  methods: {
    resetFormData () {
      this.formData = {
        description: '',
        monthDayFinish: '',
        monthDayStart: '',
        monthFinish: '',
        monthStart: '',
        timeToFinishHour: '',
        timeToFinishMin: '',
        timeToStartHour: '',
        timeToStartMin: '',
        weekDayFinish: '',
        weekDayStart: ''
      }
      this.formDataErrors = {}
    },
    async getFormData (id) {
      this.$vs.loading({container: '#AddTimeConditionFormContainer'})
      try {
        const response = await TimeCondition.view({ id })
        this.formData = response.data.data
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$vs.loading.close('#AddTimeConditionFormContainer > .con-vs-loading')
    },
    async saveFormData () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addTimeConditionButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await TimeCondition.store({ ...this.formData, keyword: this.activeKeyword, type: this.activeType })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.resetFormData()
          this.$emit('addTimeConditionSuccess')
        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })

        this.formDataErrors = this.__getTranslatedValidationErrors(errors.validationErrors)
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#addTimeConditionButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
  #addTimeConditionButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
